// extracted by mini-css-extract-plugin
export default {"askQuestionTopText":"D3-z","yourQuestionLabel":"E3-z","notAuthedMessage":"F3-z","form":"G3-z","textarea":"H3-z","error":"I3-z","disabled":"J3-z","edited":"K3-z","submit":"L3-z"};